import {
  IBase,
  ICachedAddress,
  ICoordinate,
  IFavoriteResponse,
  IReservation,
  ISearchStop,
  IServiceInfo,
  IStop,
  IStopAvailabilityTimes
} from '../../../models'
import {
  BusStopsStepTypeKeys,
  ISetIsSearchingCoordsInMapAction,
  ISetIsMapCenterWithinOutlinesAction,
  ISetPreviewBusStopAction,
  ISetPreviewOriginStopAction,
  ISetPreviewDestinationStopAction,
  ILoadCachedAddressesAction,
  ISetCachedAddressesAction,
  IAddCachedAddressAction,
  IFetchStopAvailabilityTimesAction,
  ISetIsFetchingStopAvailabilityTimesAction,
  ISetStopAvailabilityTimesAction,
  IResetStopAvailabilityTimesAction,
  IFetchDestinationBusStopsAction,
  IFetchDestinationBusStopsSuccesfulAction,
  IFetchServicesAction,
  IFetchServicesSuccessfulAction,
  IResetMapChangedCenterAction,
  IResetNewReservationFieldsAction,
  ISearchStopCoordinatesAction,
  ISearchStopsAction,
  ISetBusStopAction,
  ISetFavoriteNewReservationFieldsAction,
  ISetIsFetchingDestinationBusStopsAction,
  ISetIsFetchingServicesAction,
  ISetIsSeachingAction,
  ISetMapChangedCenterAction,
  ISetNewReservationFieldsAction,
  ISetRoundTripAction,
  ISetSearchedStopResultAction,
  ISetSearchStopsAction,
  ISetSelectMarkerFlagAction,
  ISetServiceSelectedAction,
  ISetUserLocationAction,
  ISetShowTripTypeOptionsActions,
  ISetShowSingleStopModalAction,
  ISetSingleBusStopAction,
  IResetSingleBusStopAction
} from '../../types'

export function resetNewReservationFieldsAction(): IResetNewReservationFieldsAction {
  return { type: BusStopsStepTypeKeys.RESET_NEW_RESERVATION_FIELDS }
}

export function setNewReservationFieldsAction(reservation: IReservation): ISetNewReservationFieldsAction {
  return { type: BusStopsStepTypeKeys.SET_NEW_RESERVATION_FIELDS, payload: reservation }
}

export function setFavoriteNewReservationFieldsAction(
  favorite: IFavoriteResponse
): ISetFavoriteNewReservationFieldsAction {
  return { type: BusStopsStepTypeKeys.SET_FAVORITE_NEW_RESERVATION_FIELDS, payload: favorite }
}

export function fetchServicesAction(): IFetchServicesAction {
  return { type: BusStopsStepTypeKeys.FETCH_SERVICES }
}

export function setIsFetchingServicesAction(): ISetIsFetchingServicesAction {
  return { type: BusStopsStepTypeKeys.FETCHING_SERVICES }
}

export function fetchServicesSuccessfulAction(serviceInfos: IServiceInfo[]): IFetchServicesSuccessfulAction {
  return { type: BusStopsStepTypeKeys.FETCH_SERVICES_SUCCESSFUL, payload: serviceInfos }
}

export function setIsSeachingAction(isSearching: boolean): ISetIsSeachingAction {
  return { type: BusStopsStepTypeKeys.SET_IS_SEARCHING, payload: isSearching }
}

export function searchStopsAction(stopNameToSearch: string): ISearchStopsAction {
  return { type: BusStopsStepTypeKeys.SEARCH_STOPS, payload: stopNameToSearch }
}

export function setSearchStopsAction(stops: IBase[]): ISetSearchStopsAction {
  return { type: BusStopsStepTypeKeys.SET_SEARCH_STOPS, payload: stops }
}

export function setSearchedStopResultAction(searchResult: {
  name: string
}): ISetSearchedStopResultAction {
  return { type: BusStopsStepTypeKeys.SET_SEARCHED_RESULT, payload: searchResult }
}

export function setSelectMarkerFlagAction(markerSelected: boolean): ISetSelectMarkerFlagAction {
  return { type: BusStopsStepTypeKeys.SET_SELECT_MARKER_FLAG, payload: markerSelected }
}

export function searchStopCoordinatesAction(stop: ISearchStop): ISearchStopCoordinatesAction {
  return { type: BusStopsStepTypeKeys.SEARCH_STOP_COORDINATES, payload: stop }
}

export function setBusStopAction({ stop }: {
  stop: IStop
}): ISetBusStopAction {
  return { type: BusStopsStepTypeKeys.SET_BUS_STOP, payload: { stop } }
}

export function fetchDestinationBusStopsAction({
  stop,
  idTown
}: {
  stop: IStop
  idTown: number
}): IFetchDestinationBusStopsAction {
  return { type: BusStopsStepTypeKeys.FETCH_DESTINATION_BUS_STOPS, payload: { stop, idTown } }
}

export function setIsFetchingDestinationBusStopsAction(): ISetIsFetchingDestinationBusStopsAction {
  return { type: BusStopsStepTypeKeys.FETCHING_DESTINATION_BUS_STOPS }
}

export function fetchDestinationBusStopsSuccesfulAction(stops: IStop[]): IFetchDestinationBusStopsSuccesfulAction {
  return { type: BusStopsStepTypeKeys.FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL, payload: stops }
}

export function setMapChangedCenterAction(coords: ICoordinate): ISetMapChangedCenterAction {
  return { type: BusStopsStepTypeKeys.SET_MAP_CHANGED_CENTER, payload: coords }
}

export function resetMapChangedCenterAction(): IResetMapChangedCenterAction {
  return { type: BusStopsStepTypeKeys.RESET_MAP_CHANGED_CENTER }
}

export function setServiceSelectedAction(serviceInfo: IServiceInfo, selected: boolean): ISetServiceSelectedAction {
  return { type: BusStopsStepTypeKeys.SET_SERVICE_SELECTED, payload: { serviceInfo, selected } }
}

export function setUserLocationAction(coordinates: ICoordinate | undefined): ISetUserLocationAction {
  return { type: BusStopsStepTypeKeys.SET_USER_LOCATION, payload: coordinates }
}

export function setRoundTripAction(roundTrip: boolean): ISetRoundTripAction {
  return { type: BusStopsStepTypeKeys.SET_ROUND_TRIP, payload: roundTrip }
}

export function setShowTripTypeOptionsActions(show: boolean): ISetShowTripTypeOptionsActions {
  return { type: BusStopsStepTypeKeys.SET_SHOW_TRIP_TYPE_OPTIONS, payload: show }
}

export function setShowSingleStopModalAction(isSingleStopModalOpen: boolean, stop?: IStop): ISetShowSingleStopModalAction {
  return { type: BusStopsStepTypeKeys.SHOW_SINGLE_STOP_MODAL, payload: {isSingleStopModalOpen: isSingleStopModalOpen, stop: stop}}
}

export function setSingleBusStopDirectionAction(isOrigin: boolean, stop?: IStop): ISetSingleBusStopAction {
  return { type: BusStopsStepTypeKeys.SET_SINGLE_BUS_STOP_DIRECTION, payload: {isOrigin, stop}}
}

export function resetSingleBusStopAction(): IResetSingleBusStopAction {
  return { type: BusStopsStepTypeKeys.RESET_SINGLE_BUS_STOP}
}

export function setIsSearchingCoordsInMapAction(isSearchingCoordsInMap: boolean): ISetIsSearchingCoordsInMapAction {
  return { type: BusStopsStepTypeKeys.SET_IS_SEARCHING_COORDS_IN_MAP, payload: isSearchingCoordsInMap }
}

export function setIsMapCenterWithinOutlinesAction(isWithin: boolean): ISetIsMapCenterWithinOutlinesAction {
  return { type: BusStopsStepTypeKeys.SET_IS_MAP_CENTER_WITHIN_OUTLINES, payload: isWithin }
}

export function setPreviewBusStopAction(coordinates: ICoordinate, isOrigin: boolean): ISetPreviewBusStopAction {
  return { type: BusStopsStepTypeKeys.SET_PREVIEW_BUS_STOP, payload: { coordinates, isOrigin } }
}

export function setPreviewOriginStopAction(stop?: IStop): ISetPreviewOriginStopAction {
  return { type: BusStopsStepTypeKeys.SET_PREVIEW_ORIGIN_STOP, payload: stop }
}

export function setPreviewDestinationStopAction(stop?: IStop): ISetPreviewDestinationStopAction {
  return { type: BusStopsStepTypeKeys.SET_PREVIEW_DESTINATION_STOP, payload: stop }
}

export function loadCachedAddressesAction(): ILoadCachedAddressesAction {
  return { type: BusStopsStepTypeKeys.LOAD_CACHED_ADDRESSES }
}

export function setCachedAddressesAction(addresses: ICachedAddress[]): ISetCachedAddressesAction {
  return { type: BusStopsStepTypeKeys.SET_CACHED_ADDRESSES, payload: addresses }
}

export function addCachedAddressAction(address: ICachedAddress): IAddCachedAddressAction {
  return { type: BusStopsStepTypeKeys.ADD_CACHED_ADDRESS, payload: address }
}
export function fetchStopAvailabilityTimesAction(
  stopId: number,
  date: Date,
  serviceInfos: IServiceInfo[]
): IFetchStopAvailabilityTimesAction {
  return {
    type: BusStopsStepTypeKeys.FETCH_STOP_AVAILABILITY_TIMES,
    payload: { stopId, date, serviceInfos }
  }
}

export function setIsFetchingStopAvailabilityTimesAction(isFetching: boolean): ISetIsFetchingStopAvailabilityTimesAction {
  return { type: BusStopsStepTypeKeys.SET_IS_FETCHING_STOP_AVAILABILITY_TIMES, payload: isFetching }
}

export function setStopAvailabilityTimesAction(times: IStopAvailabilityTimes[]): ISetStopAvailabilityTimesAction {
  return { type: BusStopsStepTypeKeys.SET_STOP_AVAILABILITY_TIMES, payload: times }
}

export function resetStopAvailabilityTimesAction(): IResetStopAvailabilityTimesAction {
  return { type: BusStopsStepTypeKeys.RESET_STOP_AVAILABILITY_TIMES }
}
